var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4004 0.199951H16.0004C15.6821 0.199951 15.3769 0.326379 15.1519 0.551423C14.9268 0.776467 14.8004 1.08169 14.8004 1.39995V21.7904H19.6004V1.39995C19.6004 1.08169 19.474 0.776467 19.2489 0.551423C19.0239 0.326379 18.7186 0.199951 18.4004 0.199951ZM11.2004 7.39995H8.80039C8.48213 7.39995 8.17691 7.52638 7.95186 7.75142C7.72682 7.97647 7.60039 8.28169 7.60039 8.59995V21.7904H12.4004V8.59995C12.4004 8.28169 12.274 7.97647 12.0489 7.75142C11.8239 7.52638 11.5187 7.39995 11.2004 7.39995ZM4.00039 14.6H1.60039C1.28213 14.6 0.976906 14.7264 0.751862 14.9514C0.526819 15.1765 0.400391 15.4817 0.400391 15.8V21.7904H5.20039V15.8C5.20039 15.4817 5.07396 15.1765 4.84892 14.9514C4.62387 14.7264 4.31865 14.6 4.00039 14.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJob);
export default __webpack_public_path__ + "static/media/new_job.3fa0b90270052ad2361872f9e32b948f.svg";
export { ForwardRef as ReactComponent };